import { Component, OnDestroy, OnInit } from '@angular/core'
import { NgIf } from '@angular/common'
import { LanguageService } from '../../../services/language.service'
import { Subscription } from 'rxjs'
import { EventService } from '../../../services/event.service'
import { Language } from 'htv-lib'
import { RouterService } from '../../../services/router.service'

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [NgIf],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  languages: Language[] = []
  isShowed = false
  selectedLanguage!: Language
  selectedLanguageIndex = 0
  currentLanguageIndex = 0

  eventSubscription?: Subscription

  constructor(
    private languageService: LanguageService,
    private eventService: EventService,
    private routerService: RouterService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.registerEventListener()
    this.selectedLanguage = this.languageService.getSelectedLanguage()
    this.languageService.isLoading$.subscribe(this.handleLanguageLoading.bind(this))
  }

  ngOnDestroy(): void {
    this.eventSubscription?.unsubscribe()
  }

  languageClicked(language: Language | undefined) {
    if (language) {
      this.languageService.setSelectedLanguage(language)
    }
    this.routerService.goToHome()
  }

  handleLanguageLoading(isLanguageLoading: boolean): void {
    if (!isLanguageLoading) {
      this.languages = this.languageService.availableLanguageList.sort((a, b) => (a.nativeName < b.nativeName ? -1 : 1))

      const index = this.languages.findIndex(l => l.code === this.selectedLanguage.code)
      if (index >= 0) {
        this.selectedLanguageIndex = index
        this.currentLanguageIndex = this.selectedLanguageIndex
      }
    }
  }

  registerEventListener(): void {
    this.eventSubscription = this.eventService.keyDown.subscribe((key: string) => {
      switch (key) {
        case 'ARROW-UP':
          if (this.currentLanguageIndex > 0) {
            this.currentLanguageIndex--
          }
          break
        case 'ARROW-DOWN':
          if (this.currentLanguageIndex < this.languages.length - 1) {
            this.currentLanguageIndex++
          }
          break
        default:
          break
      }
    })
  }
}
